// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n  .t89e4::after {\n    content: ' ';\n    display: block;\n    position: absolute;\n    left: -16px;\n    top: -8px;\n    bottom: -8px;\n    width: 4px;\n    background: white;\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selected": "t89e4"
};
export default ___CSS_LOADER_EXPORT___;
